module.exports = __webpack_public_path__ + "07152918295e3ac2bc53b9f7a2dc4e3c.svg";